import { Badge } from '@/components/ui/badge';
import { useEntitlementsLoading } from '@/hooks/use-entitlements';
import { cn } from '@/lib/utils';
import { useSession } from '@/hooks/useSessionHook';

interface UserTierBadgeProps {
  className?: string;
}

/**
 * Displays the current user's subscription tier as a badge.
 * Automatically updates in real-time when the subscription changes.
 */
export function UserTierBadge({ className }: UserTierBadgeProps) {
  const isLoading = useEntitlementsLoading();
  const { profile } = useSession();
  const isAdmin = profile?.app_role === 'admin';

  if (isLoading && isAdmin) {
    return (
      <Badge
        variant="secondary"
        className={cn('jr-pill animate-pulse rounded-full px-1.75 py-0.5 text-[0.6rem] font-semibold leading-none', className)}
        data-testid="user-tier-badge-loading"
      >
        ...
      </Badge>
    );
  }

  if (!isAdmin) {
    return null;
  }

  return (
    <Badge
      variant="secondary"
      className={cn('jr-pill min-h-0 rounded-full px-1.75 py-0.5 text-[0.6rem] font-semibold leading-none', className)}
      data-testid="user-tier-badge"
      data-tier="admin"
    >
      Admin
    </Badge>
  );
}
